var map = {
	"./AD.svg": 3569,
	"./AE.svg": 5311,
	"./AF.svg": 4076,
	"./AG.svg": 5932,
	"./AI.svg": 6525,
	"./AL.svg": 3986,
	"./AM.svg": 6872,
	"./AO.svg": 8988,
	"./AQ.svg": 3079,
	"./AR.svg": 1495,
	"./AS.svg": 6636,
	"./AT.svg": 4905,
	"./AU.svg": 8463,
	"./AW.svg": 1153,
	"./AX.svg": 3829,
	"./AZ.svg": 578,
	"./BA.svg": 8431,
	"./BB.svg": 2343,
	"./BD.svg": 5223,
	"./BE.svg": 1971,
	"./BF.svg": 6688,
	"./BG.svg": 6253,
	"./BH.svg": 8116,
	"./BI.svg": 2939,
	"./BJ.svg": 5014,
	"./BL.svg": 4676,
	"./BM.svg": 4589,
	"./BN.svg": 8176,
	"./BO.svg": 2271,
	"./BQ-BO.svg": 470,
	"./BQ-SA.svg": 6875,
	"./BQ-SE.svg": 6524,
	"./BR.svg": 6966,
	"./BS.svg": 1974,
	"./BT.svg": 2897,
	"./BV.svg": 737,
	"./BW.svg": 5838,
	"./BY.svg": 5691,
	"./BZ.svg": 4641,
	"./CA.svg": 2894,
	"./CC.svg": 8552,
	"./CD.svg": 1397,
	"./CF.svg": 3125,
	"./CG.svg": 2369,
	"./CH.svg": 8660,
	"./CI.svg": 5417,
	"./CK.svg": 9193,
	"./CL.svg": 7368,
	"./CM.svg": 824,
	"./CN.svg": 2327,
	"./CO.svg": 9994,
	"./CR.svg": 96,
	"./CU.svg": 5459,
	"./CV.svg": 6009,
	"./CW.svg": 3967,
	"./CX.svg": 3576,
	"./CY.svg": 3227,
	"./CZ.svg": 5097,
	"./DE.svg": 6446,
	"./DJ.svg": 4496,
	"./DK.svg": 4215,
	"./DM.svg": 1403,
	"./DO.svg": 5422,
	"./DZ.svg": 5737,
	"./EC.svg": 8126,
	"./EE.svg": 786,
	"./EG.svg": 8575,
	"./EH.svg": 5302,
	"./ER.svg": 4677,
	"./ES.svg": 1215,
	"./ET.svg": 3024,
	"./FI.svg": 486,
	"./FJ.svg": 4019,
	"./FK.svg": 9709,
	"./FM.svg": 1459,
	"./FO.svg": 4334,
	"./FR.svg": 4932,
	"./FW.svg": 6317,
	"./GA.svg": 3098,
	"./GB - 副本.svg": 5849,
	"./GB-1.svg": 7875,
	"./GB-SCT.svg": 7858,
	"./GB-UKM.svg": 4509,
	"./GB-WLS.svg": 1927,
	"./GB.svg": 2606,
	"./GD.svg": 7970,
	"./GE.svg": 758,
	"./GF.svg": 770,
	"./GG.svg": 5261,
	"./GH.svg": 6946,
	"./GI.svg": 2330,
	"./GL.svg": 3706,
	"./GM.svg": 386,
	"./GN.svg": 1863,
	"./GP.svg": 7799,
	"./GQ.svg": 6573,
	"./GR.svg": 366,
	"./GS.svg": 8195,
	"./GT.svg": 2076,
	"./GU.svg": 7867,
	"./GW.svg": 8174,
	"./GY.svg": 6735,
	"./HK.svg": 6202,
	"./HM.svg": 3421,
	"./HN.svg": 8413,
	"./HR.svg": 6555,
	"./HT.svg": 2861,
	"./HU.svg": 4198,
	"./ID.svg": 8613,
	"./IE.svg": 4570,
	"./IL.svg": 1885,
	"./IM.svg": 4276,
	"./IN.svg": 5070,
	"./IO.svg": 699,
	"./IQ.svg": 3280,
	"./IR.svg": 6685,
	"./IS.svg": 8490,
	"./IT.svg": 9532,
	"./JE.svg": 868,
	"./JM.svg": 7105,
	"./JO.svg": 2122,
	"./JP.svg": 9148,
	"./KE.svg": 2783,
	"./KG.svg": 8734,
	"./KH.svg": 4730,
	"./KI.svg": 6004,
	"./KM.svg": 7289,
	"./KN.svg": 2128,
	"./KP.svg": 4136,
	"./KR.svg": 7036,
	"./KW.svg": 2027,
	"./KY.svg": 9081,
	"./KZ.svg": 776,
	"./LA.svg": 5418,
	"./LB.svg": 808,
	"./LC.svg": 3468,
	"./LI.svg": 4236,
	"./LK.svg": 1223,
	"./LR.svg": 7038,
	"./LS.svg": 4558,
	"./LT.svg": 91,
	"./LU.svg": 6605,
	"./LV.svg": 7602,
	"./LY.svg": 1716,
	"./MA.svg": 250,
	"./MC.svg": 8865,
	"./MD.svg": 2419,
	"./ME.svg": 6368,
	"./MF.svg": 2621,
	"./MG.svg": 446,
	"./MH.svg": 8363,
	"./MK.svg": 5667,
	"./ML.svg": 6157,
	"./MM.svg": 8243,
	"./MN.svg": 9530,
	"./MO.svg": 660,
	"./MP.svg": 6912,
	"./MQ.svg": 5071,
	"./MR.svg": 9874,
	"./MS.svg": 3483,
	"./MT.svg": 7553,
	"./MU.svg": 1853,
	"./MV.svg": 7830,
	"./MW.svg": 1131,
	"./MX.svg": 5452,
	"./MY.svg": 1723,
	"./MZ.svg": 8489,
	"./NA.svg": 2658,
	"./NC.svg": 1267,
	"./NE.svg": 19,
	"./NF.svg": 6941,
	"./NG.svg": 9859,
	"./NI.svg": 9283,
	"./NL.svg": 6137,
	"./NO.svg": 178,
	"./NP.svg": 629,
	"./NR.svg": 5373,
	"./NU.svg": 9838,
	"./NZ.svg": 7170,
	"./OM.svg": 5865,
	"./PA.svg": 5635,
	"./PE.svg": 8974,
	"./PF.svg": 4774,
	"./PG.svg": 7652,
	"./PH.svg": 5889,
	"./PK.svg": 7897,
	"./PL.svg": 5061,
	"./PM.svg": 9265,
	"./PN.svg": 4381,
	"./PR.svg": 412,
	"./PS.svg": 8401,
	"./PT.svg": 3934,
	"./PW.svg": 5306,
	"./PY.svg": 4885,
	"./QA.svg": 9448,
	"./RE.svg": 6787,
	"./RO.svg": 5156,
	"./RS.svg": 8224,
	"./RU.svg": 2072,
	"./RW.svg": 8122,
	"./SA.svg": 2745,
	"./SB.svg": 509,
	"./SC.svg": 9814,
	"./SD.svg": 3710,
	"./SE.svg": 8619,
	"./SG.svg": 8889,
	"./SH.svg": 5749,
	"./SI.svg": 6871,
	"./SJ.svg": 7539,
	"./SK.svg": 1075,
	"./SL.svg": 2853,
	"./SM.svg": 3439,
	"./SN.svg": 2864,
	"./SO.svg": 3268,
	"./SR.svg": 9501,
	"./SS.svg": 1003,
	"./ST.svg": 9069,
	"./SV.svg": 2215,
	"./SX.svg": 8494,
	"./SY.svg": 2966,
	"./SZ.svg": 6498,
	"./TC.svg": 5912,
	"./TD.svg": 2348,
	"./TF.svg": 1424,
	"./TG.svg": 7326,
	"./TH.svg": 986,
	"./TJ.svg": 4225,
	"./TK.svg": 5289,
	"./TL.svg": 5074,
	"./TM.svg": 4977,
	"./TN.svg": 9138,
	"./TO.svg": 1372,
	"./TR.svg": 4064,
	"./TT.svg": 2840,
	"./TV.svg": 7143,
	"./TW.svg": 7778,
	"./TZ.svg": 579,
	"./UA.svg": 7797,
	"./UG.svg": 1201,
	"./US.svg": 5741,
	"./UY.svg": 563,
	"./UZ.svg": 2710,
	"./VA.svg": 6632,
	"./VC.svg": 9510,
	"./VE.svg": 2061,
	"./VG.svg": 341,
	"./VI.svg": 8928,
	"./VN.svg": 7809,
	"./VU.svg": 1004,
	"./WF.svg": 8384,
	"./WS.svg": 6776,
	"./XK.svg": 5813,
	"./YE.svg": 5429,
	"./YT-UNF.svg": 3142,
	"./ZA.svg": 849,
	"./ZM.svg": 7703,
	"./ZW.svg": 7932,
	"./regionFlag.svg": 5569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;